import { FC } from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { cn } from "@/utils/tailwind/utils";

type MessageDialogProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  title?: string;
  message?: string;
  actionButtonLabel?: string;
  onClickAction?: () => void;
  actionButtonBg?: string;
  cancelButtonLabel?: string;
  contentClassName?: string;
};

export const MessageDialog: FC<MessageDialogProps> = ({
  open,
  setOpen,
  title,
  message,
  actionButtonLabel,
  cancelButtonLabel,
  onClickAction,
  actionButtonBg,
  contentClassName,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent className={cn("max-w-[calc(100vw-32px)] sm:max-w-lg", contentClassName)}>
        <AlertDialogHeader>
          {title && <AlertDialogTitle className="break-all">{title}</AlertDialogTitle>}
          <AlertDialogDescription>{message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          {cancelButtonLabel && <AlertDialogCancel>{cancelButtonLabel}</AlertDialogCancel>}
          {actionButtonLabel && (
            <AlertDialogAction
              className={actionButtonBg}
              onClick={() => {
                onClickAction?.();
              }}
            >
              {actionButtonLabel}
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export const AlertMessageDialog: FC<Pick<MessageDialogProps, "open" | "message" | "setOpen">> = ({
  open,
  message,
  setOpen,
}) => {
  return <MessageDialog open={open} message={message} actionButtonLabel="OK" setOpen={setOpen} />;
};

export const ConfirmMessageDialog: FC<MessageDialogProps> = ({
  open,
  title,
  message,
  setOpen,
  actionButtonLabel,
  cancelButtonLabel,
  onClickAction,
  actionButtonBg,
  contentClassName,
}) => {
  return (
    <MessageDialog
      open={open}
      message={message}
      title={title}
      actionButtonLabel={actionButtonLabel}
      cancelButtonLabel={cancelButtonLabel}
      setOpen={setOpen}
      onClickAction={onClickAction}
      actionButtonBg={actionButtonBg}
      contentClassName={contentClassName}
    />
  );
};
